
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { LoaderProvider } from './contexts/LoaderContext';
import App from './pages/App';
import reportWebVitals from './reportWebVitals';
import { store } from './store/configureStore';
import './styles/main.scss';

/**
 * Entry point for the Pets application.
 *
 * - Imports necessary dependencies including React, Redux, context providers, and styles.
 * - Asynchronously retrieves the preloaded state for Redux store initialization.
 * - Creates the root React DOM node and renders the application within it.
 * - Wraps the application with ReduxProvider for state management and AppContextProvider for global context.
 * - Uses React.StrictMode to highlight potential problems in the application.
 *
 * @file This file bootstraps the frontend application and sets up global providers.
 */
(async () => {

    const container = document.getElementById('root');
    if (!container) {
        throw new Error("Root container not found");
    }
    const root = createRoot(container);

    root.render(
        <Provider store={store}>
            <BrowserRouter>
                <LoaderProvider>
                  <React.StrictMode>
                      <App />
                      {/* Toast notifications container */}
                      {React.createElement(require('./components/UI/ToastContainerComponent').default)}
                  </React.StrictMode>
                </LoaderProvider>
            </BrowserRouter>
        </Provider>
    );
})();

reportWebVitals();
